module.exports = __webpack_public_path__ + "img/2.25d0b933.png";